export const CATEGORY_OPTIONS = [
  { value: "Tavuk kategorisi", label: "Tavuk kategorisi" },
  { value: "Et kategorisi", label: "Et kategorisi" },
  { value: "Sebze kategorisi", label: "Sebze kategorisi" },
  { value: "Baklagiller", label: "Baklagiller" },
  { value: "Deniz mahsülleri", label: "Deniz mahsülleri" },
  { value: "Corba", label: "Çorba" },
  { value: "Hamur işleri", label: "Hamur işleri" },
  { value: "Makarna", label: "Makarna" },
  { value: "Glutensiz kategori", label: "Glutensiz kategori" },
  { value: "Vegan kategorisi", label: "Vegan kategorisi" },
  { value: "Atıştırmalık ve Tatlı", label: "Atıştırmalık ve Tatlı" },
  { value: "Diyetisyen onaylı tarifler", label: "Diyetisyen onaylı tarifler" },
];
